import React from 'react';
import styled from 'styled-components';
import ProdSliderImg from './ProdSliderImg';
import { useEffect } from 'react';
import { useState } from 'react';
import { values } from 'lodash';
import { Log } from '../../../lib/util/CustomUtil';
import { useHistory, Link } from 'react-router-dom';

/**
 * 상품 가로 슬라이드 컴포넌트 
 */
const ProdSliderBlock = styled.div`
    width: 680px;
    margin: 0 0 0 auto;
    overflow: hidden;
`;

const ProdDetailSlideBlock = styled.div`
    width: 700px;
    -webkit-transform: translateX(-10px);
    -ms-transform: translateX(-10px);
    transform: translateX(-10px);
`;

const ProdSlickListBlock = styled.div`
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
`;

const PrevBtnBlock = styled.button`
    left: 10px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    position: absolute;
    top: 0;
    width: 50px;
    height: 100%;
    display: ${props => props.isShow};
    background-image:url(${props => props.img});
    // &:hover {
    //     transition: all 0.3s ease-in-out;
    //     background-color: #e0e0e0;
    //     color: #fff;
    // }
`;

const NextBtnBlock = styled.button`
    right: 10px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    position: absolute;
    top: 0px;
    width: 50px;
    height: 100%;
    display: ${props => props.isShow};
    background-image:url(${props => props.img});
    // &:hover {
    //     transition: all 0.3s ease-in-out;
    //     background-color: #e0e0e0;
    //     color: #fff;
    // }
`;

const ProdSlider = ({ items, count }) => {

    const [startSlide, setStartSlide] = useState(0);
    const [dispSlide, setDispSlide] = useState([]);
    const dispNum = 5;
    const history = useHistory();

    useEffect(() => {
        // setImgInfo(items)

        if (items != null && count > dispNum) {
            setDispSlide(items.slice(startSlide, startSlide + dispNum));
        } else {
            setDispSlide(items);
        }
    }, [startSlide, items])

    if (dispSlide.length === 0) {
        return <ProdSliderBlock></ProdSliderBlock>
    }

    const handlePrevClick = () => {
        setStartSlide(startSlide - 1)
    }

    const handleNextClick = () => {
        setStartSlide(startSlide + 1)
    }

    return (
        <ProdSliderBlock>

            <ProdDetailSlideBlock>

                <ProdSlickListBlock>
                    {
                        dispSlide.map((item, idx) => {
                            return (<Link key={idx} to={"/prod?prodid=" + item[2]}>
                                <ProdSliderImg
                                    img={item[0]}
                                    text={item[1]}
                                /></Link>)
                        })
                    }
                </ProdSlickListBlock>
                <PrevBtnBlock
                    img={"/assets/images/icon/es_detail-icon-prev.png"}
                    isShow={startSlide > 0 ? 'block' : 'none'}
                    onClick={handlePrevClick} />
                <NextBtnBlock
                    img={"/assets/images/icon/es_detail-icon-next.png"}
                    isShow={(startSlide + dispNum) < count ? 'block' : 'none'}
                    onClick={handleNextClick} />
            </ProdDetailSlideBlock>
        </ProdSliderBlock>
    );
};

export default ProdSlider;